export const SettingsSkeleton = () => {
  return (
    <div className="p-6 w-full flex flex-col gap-10">
      <div className="bg-skeleton animate-pulse h-24 rounded-lg" />
      <div className="bg-skeleton animate-pulse h-24 rounded-lg" />
    </div>
  )
}
